import * as PostMessagesActionTypes from './action-types.constants';
import * as PostMessagesActions from './post-messages.actions';

function init(storeAPI) {
    const receiveMessage = (event) => {

        const { origin, data } = event;
        if (origin.indexOf("tpc.googlesyndication.com") === -1 && origin.indexOf("medscape.com") === -1 && origin.indexOf("ads.localhost.com") === -1) {
            return;
        } else if (typeof data === "object") {
            storeAPI.dispatch(PostMessagesActions.message(data))
        }
    }
    window.addEventListener("message", receiveMessage, true);

}

const PostMessagesMiddleware = storeAPI => next => action => {
    //const state = storeAPI.getState();
    let result = next(action);
    //console.log("[PostMessagesMiddleware] dispatch:",action.type);
    //const nextState = storeAPI.getState();
    switch (action.type) {
        case PostMessagesActionTypes.INIT:
            //console.log("[PostMessagesMiddleware] dispatch:",action.type,"\tstate:",nextState);
            init(storeAPI);
            break;
    }

    return result
}

export default PostMessagesMiddleware;